import React from "react";
import {
  ArrowLeftOutlined,
  HomeOutlined,
  ReloadOutlined,
} from "@ant-design/icons";
import { Button, Result } from "antd";
import { useTranslation } from "react-i18next";
import * as Sentry from "@sentry/react";
import { useHistory } from "react-router";

interface IProps {}

const RouteErrorBoundary: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const { push, goBack } = useHistory();
  return (
    <Sentry.ErrorBoundary
      fallback={({ error }) => {
        return (
          <Result
            status="error"
            title="Oops!"
            subTitle={
              process.env.NODE_ENV === "development" ? (
                <code>{error?.message}</code>
              ) : (
                t("common.errors.msg")
              )
            }
            extra={[
              <Button
                icon={<ArrowLeftOutlined />}
                type="default"
                onClick={() => goBack()}
                key="back"
              >
                {t("common.back")}
              </Button>,
              <Button
                icon={<ReloadOutlined />}
                type="default"
                onClick={() => window.location.reload()}
                key="reload"
              >
                {t("common.retry")}
              </Button>,
              <Button
                icon={<HomeOutlined />}
                type="default"
                onClick={() => {
                  push("/");
                }}
                key="home"
              >
                {t("common.home")}
              </Button>,
            ]}
          />
        );
      }}
    >
      {props.children}
    </Sentry.ErrorBoundary>
  );
};

export default RouteErrorBoundary;
